module.exports = __webpack_public_path__ + "img/community01.a1b3f125.png";